var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cards-fill-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.251 8.25V18.75C19.2505 19.1477 19.0923 19.529 18.8111 19.8102C18.5299 20.0914 18.1487 20.2495 17.751 20.25H4.25098C3.85329 20.2495 3.47202 20.0914 3.19082 19.8102C2.90961 19.529 2.75143 19.1477 2.75098 18.75V8.25C2.75143 7.85231 2.90961 7.47105 3.19082 7.18984C3.47202 6.90864 3.85329 6.75045 4.25098 6.75H17.751C18.1487 6.75045 18.5299 6.90864 18.8111 7.18984C19.0923 7.47105 19.2505 7.85231 19.251 8.25ZM20.751 3.75H6.50098C6.30206 3.75 6.1113 3.82902 5.97065 3.96967C5.82999 4.11032 5.75098 4.30109 5.75098 4.5C5.75098 4.69891 5.82999 4.88968 5.97065 5.03033C6.1113 5.17098 6.30206 5.25 6.50098 5.25H20.751V16.5C20.751 16.6989 20.83 16.8897 20.9706 17.0303C21.1113 17.171 21.3021 17.25 21.501 17.25C21.6999 17.25 21.8907 17.171 22.0313 17.0303C22.172 16.8897 22.251 16.6989 22.251 16.5V5.25C22.2505 4.85231 22.0923 4.47105 21.8111 4.18984C21.5299 3.90864 21.1487 3.75045 20.751 3.75Z",
    fill: "#304FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCard);
export default __webpack_public_path__ + "static/media/accountCard.117d73e01d77a61df64a30a7017a8e50.svg";
export { ForwardRef as ReactComponent };